import React, { useState, useEffect } from 'react';
import SmartTable, { SmartTableColumn } from '../../../shared/components/SmartTable';
import LayoutWrapper from '../../../shared/components/LayoutWrapper';
import { useAuth } from '../../../shared/hooks/useAuth';
import api from '../../../shared/utils/api';
import { convertToMongolianImmediate } from '../../../shared/utils/mongolianConverter';
import SuccessPopup from '../../../shared/components/SuccessPopup';
import ErrorPopup from '../../../shared/components/ErrorPopup';

interface Customer {
  CustomerID: string;
  CustomerName: string;
  TIN?: string;
  Phone?: string;
  Email?: string;
  EBarimtRegistered?: boolean;
  NDRegistered?: boolean;
  TaxRegistered?: boolean;
  Active?: boolean;
  [key: string]: any;
}

const AdminHariltsagchPage: React.FC = () => {
  const { userAuth } = useAuth();
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState(true);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const defaultColumns: SmartTableColumn[] = [
    { key: 'CustomerID', label: 'Код' },
    { key: 'CustomerName', label: 'Нэр' },
    { key: 'TinCode', label: 'ТИН код' },
    { key: 'Phone', label: 'Утас' },
    { key: 'Mail', label: 'Имэйл' },
    { key: 'Address', label: 'Хаяг' },
    { key: 'DirectorRegister', label: 'Захирлын регистрийн дугаар' },
    { key: 'DrFirstname', label: 'Захирлын нэр' },
    { key: 'DrLastname', label: 'Захирлын овог' },
    { key: 'EBarimtRegistered', label: 'ТГҮ бүртгэлтэй' },
    { key: 'IsVatPayer', label: 'НӨАТ төлөгч' },
    { key: 'Active', label: 'Идэвхтэй' },
    { key: 'CreatedDate', label: 'Үүсгэсэн огноо' }
  ];

  const transformCustomerData = (customers: Customer[]) => {
    return customers.map(customer => {
      const transformed: any = { ...customer };
      
      // Handle boolean fields
      if (customer.EBarimtRegistered !== undefined && customer.EBarimtRegistered !== null) {
        transformed.EBarimtRegistered = customer.EBarimtRegistered ? 'Тийм' : 'Үгүй';
      } else {
        transformed.EBarimtRegistered = 'Үгүй';
      }
      
      if (customer.IsVatPayer !== undefined && customer.IsVatPayer !== null) {
        transformed.IsVatPayer = customer.IsVatPayer ? 'Тийм' : 'Үгүй';
      } else {
        transformed.IsVatPayer = 'Үгүй';
      }
      
      if (customer.Active !== undefined && customer.Active !== null) {
        transformed.Active = customer.Active ? 'Тийм' : 'Үгүй';
      } else {
        transformed.Active = 'Үгүй';
      }

      // Format CreatedDate
      if (customer.CreatedDate) {
        const date = new Date(customer.CreatedDate);
        transformed.CreatedDate = date.toLocaleDateString('mn-MN');
      }
      
      return transformed;
    });
  };

  const fetchCustomers = () => {
    setLoading(true);
    api.get('/admin/customers')
      .then(result => {
        if (result.success) {
          setCustomers(result.data);
        } else {
          console.error('Error fetching customers:', result.message);
          setErrorMessage('Харилцагчдийн мэдээлэл ачаалахад алдаа гарлаа');
          setShowErrorPopup(true);
        }
      })
      .catch(error => {
        console.error('Error fetching customers:', error);
        setErrorMessage('Харилцагчдийн мэдээлэл ачаалахад алдаа гарлаа');
        setShowErrorPopup(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  if (loading) {
    return (
      <LayoutWrapper userAuth={userAuth}>
        <div className="p-6">
          <div className="flex justify-center items-center h-64">
            <div className="text-lg">Уншиж байна...</div>
          </div>
        </div>
      </LayoutWrapper>
    );
  }

  return (
    <LayoutWrapper userAuth={userAuth}>
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Харилцагчдын жагсаалт</h1>
        </div>

        <SmartTable
          data={transformCustomerData(customers.filter(c => c.Active !== false))}
          columns={defaultColumns}
          fetchData={fetchCustomers}
          editable={false}
          addable={false}
          rowKey="Oid"
          settingsKey="admin-hariltsagch-customers-table-view-only"
        />
        
        {/* Success Popup */}
        <SuccessPopup
          message={successMessage}
          isVisible={showSuccessPopup}
          onClose={() => setShowSuccessPopup(false)}
          duration={3000}
        />
        
        {/* Error Popup */}
        <ErrorPopup
          message={errorMessage}
          isVisible={showErrorPopup}
          onClose={() => setShowErrorPopup(false)}
          duration={5000}
        />
      </div>
    </LayoutWrapper>
  );
};

export default AdminHariltsagchPage; 